import React, { useState } from 'react';
import './Legal.css';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import logo from '../assets/tizm.png';

const Terms = ({ currentLang }) => {
  const [lang, setLang] = useState(currentLang === 'en' ? 'en' : 'tr');
  const content = {
    tr: {
      title: "SPORTİZM KULLANIM KOŞULLARI SÖZLEŞMESİ",
      content: (
        <>
          <p><strong>Son Güncelleme Tarihi:</strong> 23 Şubat 2026</p>
          <p>
            Lütfen Sportizm uygulamasını ("Uygulama") kullanmadan önce bu Kullanım Koşullarını dikkatlice okuyunuz. Uygulamayı kullanarak bu koşulları kabul etmiş sayılarsınız.
          </p>

          <h3>1. Taraflar ve Hizmetin Tanımı</h3>
          <p>
            Sportizm; kullanıcıların spor tesisleri (halı saha, basketbol sahası, tenis kortu vb.) için rezervasyon yapmasına, takım kurmasına, diğer kullanıcılara maç teklif etmesine ve turnuvalara katılmasına olanak sağlayan dijital bir platformdur. Sportizm, tesis işletmecisi veya organizatör değil, yalnızca bir aracı hizmet sağlayıcıdır.
          </p>

          <h3>2. Üyelik ve Hesap Güvenliği</h3>
          <p>Kullanıcı, kayıt sırasında verdiği bilgilerin (ad, soyad, telefon vb.) doğru ve güncel olduğunu taahhüt eder.</p>
          <p>Hesap bilgileri kişiye özeldir. Kullanıcı, şifresinin güvenliğinden bizzat sorumludur.</p>
          <p>18 yaşından küçük kullanıcıların uygulamayı veli veya vasi gözetiminde kullanması önerilir. Tesis kullanım kuralları tesise göre değişiklik gösterebilir.</p>

          <h3>3. Hizmet Kullanım Şartları</h3>
          <p><strong>Rezervasyonlar:</strong> Uygulama üzerinden yapılan tesis kiralamaları, ilgili tesisin o anki müsaitlik durumuna bağlıdır. Sportizm, tesislerin fiziki durumu veya hizmet kalitesinden sorumlu tutulamaz.</p>
          <p><strong>İptal ve İade:</strong> Rezervasyon iptal şartları her tesisin kendi politikasına göre belirlenir. Sportizm, bu süreçte aracıdır.</p>
          <p><strong>Sosyal Etkileşim:</strong> Diğer kullanıcılara yapılan maç tekliflerinde veya takım içi iletişimde; argo, küfür, tehdit veya taciz içeren söylemler hesabın kalıcı olarak kapatılmasına neden olur.</p>

          <h3>4. Sorumluluk Reddi (Önemli)</h3>
          <p><strong>Fiziksel Riskler:</strong> Spor yapmak doğası gereği fiziksel riskler barındırır. Sportizm üzerinden organize edilen maçlarda veya kiralanan tesislerde meydana gelebilecek yaralanma, sakatlanma, ölüm veya maddi hasarlardan Sportizm yönetimi hiçbir şekilde sorumlu tutulamaz. Kullanıcılar, sağlık durumlarının spor yapmaya uygun olduğunu beyan etmiş sayılırlar.</p>
          <p><strong>Eşya Kaybı:</strong> Tesislerde kaybedilen veya çalınan şahsi eşyalardan Sportizm sorumlu değildir.</p>
          <p><strong>Kullanıcı Davranışları:</strong> Diğer kullanıcılarla saha içinde veya dışında yaşanabilecek ihtilaflardan (kavga, tartışma vb.) Sportizm taraf değildir.</p>

          <h3>5. Tesis İşletmecileri ile İlişki</h3>
          <p>Sportizm, kullanıcı ile spor tesisi arasında yalnızca bir köprüdür. Tesisin standartlara uygunluğu, ışıklandırma kalitesi, zemin durumu gibi teknik detaylar tamamen tesis işletmecisinin sorumluluğundadır.</p>

          <h3>6. Hesap Silme ve Fesih</h3>
          <p>Kullanıcılar, Profil &gt; Düzenle &gt; Hesabımı Sil adımlarını izleyerek diledikleri zaman üyeliklerini sonlandırabilirler. Sportizm, kullanım koşullarına aykırı davranan kullanıcıların hesaplarını önceden bildirim yapmaksızın askıya alma veya silme hakkını saklı tutar.</p>

          <h3>7. Değişiklikler</h3>
          <p>Sportizm, sunulan hizmetleri veya bu sözleşme maddelerini dilediği zaman güncelleme hakkına sahiptir. Güncellemeler uygulama içinde yayınlandığı andan itibaren geçerlilik kazanır.</p>

          <h3>8. İletişim</h3>
          <p>Bu sözleşme ile ilgili her türlü soru ve öneriniz için bizimle iletişime geçebilirsiniz:</p>
          <p>
            E-posta: [hello@sportizm.app]<br />
            Adres: [Adresiniz]
          </p>
        </>
      )
    },
    en: {
      title: "Terms of Use",
      content: (
        <>
          <p><strong>Last Updated:</strong> February 23, 2026</p>
          <p>
            Please read these Terms of Use carefully before using the Sportizm application (the "Application"). By using the Application, you are deemed to have accepted these terms.
          </p>

          <h3>1. Parties and Description of the Service</h3>
          <p>
            Sportizm is a digital platform that allows users to make reservations for sports facilities (pitches, basketball courts, tennis courts, etc.), build teams, offer matches to other users and participate in tournaments. Sportizm is not a facility operator or organizer, but only an intermediary service provider.
          </p>

          <h3>2. Membership and Account Security</h3>
          <p>The user undertakes that the information provided during registration (name, surname, phone, etc.) is accurate and up to date.</p>
          <p>Account information is personal. The user is personally responsible for the security of their password.</p>
          <p>It is recommended that users under the age of 18 use the application under the supervision of a parent or guardian. Facility usage rules may vary depending on the facility.</p>

          <h3>3. Terms of Service Use</h3>
          <p><strong>Reservations:</strong> Facility rentals made through the application depend on the current availability of the relevant facility. Sportizm cannot be held responsible for the physical condition or service quality of the facilities.</p>
          <p><strong>Cancellation and Refund:</strong> Reservation cancellation conditions are determined according to each facility's own policy. Sportizm is an intermediary in this process.</p>
          <p><strong>Social Interaction:</strong> In match offers made to other users or in-team communication; statements containing slang, swearing, threats or harassment will result in the permanent closure of the account.</p>

          <h3>4. Disclaimer of Liability (Important)</h3>
          <p><strong>Physical Risks:</strong> Playing sports inherently carries physical risks. Sportizm management cannot be held responsible in any way for injuries, sustained injuries, death or material damages that may occur in matches organized through Sportizm or in rented facilities. Users are deemed to have declared that their health condition is suitable for playing sports.</p>
          <p><strong>Loss of Belongings:</strong> Sportizm is not responsible for personal belongings lost or stolen at the facilities.</p>
          <p><strong>User Behavior:</strong> Sportizm is not a party to disputes (fights, arguments, etc.) that may occur with other users on or off the field.</p>

          <h3>5. Relationship with Facility Operators</h3>
          <p>Sportizm is only a bridge between the user and the sports facility. Technical details such as the facility's compliance with standards, lighting quality, and surface condition are entirely the responsibility of the facility operator.</p>

          <h3>6. Account Deletion and Termination</h3>
          <p>Users can terminate their membership at any time by following the Profile &gt; Edit &gt; Delete My Account steps. Sportizm reserves the right to suspend or delete the accounts of users who act contrary to the terms of use without prior notice.</p>

          <h3>7. Changes</h3>
          <p>Sportizm has the right to update the services offered or the terms of this agreement at any time. Updates become effective from the moment they are published within the application.</p>

          <h3>8. Contact</h3>
          <p>You can contact us for any questions and suggestions regarding this agreement:</p>
          <p>
            E-mail: [hello@sportizm.app]<br />
            Address: [Your Address]
          </p>
        </>
      )
    }
  };

  const t = content[lang] || content.tr;

  return (
    <div className="legal-page">
      <Helmet>
        <title>{t.title} - Sportizm</title>
        <meta name="description" content={t.title} />
      </Helmet>
      
      <div className="legal-container">
        <div className="legal-header">
          <Link to="/">
            <img src={logo} alt="Sportizm" className="legal-logo" />
          </Link>
          <div className="legal-lang-switch">
            <button
              type="button"
              className={`legal-lang-btn ${lang === 'tr' ? 'active' : ''}`}
              onClick={() => setLang('tr')}
            >
              TR
            </button>
            <button
              type="button"
              className={`legal-lang-btn ${lang === 'en' ? 'active' : ''}`}
              onClick={() => setLang('en')}
            >
              EN
            </button>
          </div>
          <h1>{t.title}</h1>
        </div>
        
        <div className="legal-content">
          {t.content}
        </div>
      </div>
    </div>
  );
};

export default Terms;
